'use client';
/** @jsxImportSource @emotion/react */

import type { TimelineContentProps } from '@mui/lab/TimelineContent';

import MuiTimelineContent from '@mui/lab/TimelineContent';

export type { TimelineContentProps };

export const TimelineContent: React.FC<TimelineContentProps> =
  MuiTimelineContent;

TimelineContent.displayName = 'TimelineContent';
